// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../public/images/cooper_block.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../public/images/menu_separator_bg.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../public/images/bg.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
text-align: center;
flex-direction: column;
align-items: center;
justify-content: center;
/* max-width: calc(70% - 1em); */
/* min-width: 1270px; */
margin: auto;
}

.swiper-button-prev,
.swiper-button-next {
width: 50px;
height: 50px;
color: #000;
}

.Header {
display: flex;
flex-direction: row;
align-items: center;

width: 100%;
}

.Content {
display: flex;
flex-direction: column;
align-items: center;
justify-content: center;
width: 100%;
}

.Menu {
border: solid 1px #ebebeb;
padding: 4px 10px 4px 10px;
border-radius: 15px 15px 15px 15px;
background: #f9f9f9;
background: linear-gradient(to bottom, #f9f9f9 0%, #dfdfe1 100%);
filter: progid😄XImageTransform.Microsoft.gradient( startColorstr='#f9f9f9', endColorstr='#dfdfe1',GradientType=0 );
box-shadow: 0 1px 3px 1px #d3d9d9;
}

.cooper_block{
height: 70px;
background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) top center no-repeat;
}

.Footer {
display: flex;
flex-direction: column;
align-items: center;
justify-content: center;
width: 100%;
}

.App-logo {
height: 40vmin;
pointer-events: none;
}

.menu_spliter{
width: 1px;
height: 65px;
background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) center no-repeat;
}

body {
font-family: Tahoma, Arial;
font-size: 12px;
background: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) top center no-repeat #eef6f6;
}

.navbar{
background-image: -webkit-linear-gradient(top, #f5f5f5, #e8e8e8);
box-shadow: 0 3px 8px 0 rgba(0, 0, 0, 0.2), 0 0 0 1px rgba(0, 0, 0, 0.08);
}

@media (prefers-reduced-motion: no-preference) {
.App-logo {
animation: App-logo-spin infinite 20s linear;
}
}

@keyframes App-logo-spin {
from {
transform: rotate(0deg);
}
to {
transform: rotate(360deg);
}
}
.h1, h1 {
font-size: 1.8rem;
color: #5a5a5a;
font-family: Arial;
font-weight: normal;
margin-bottom: 0.5rem;
margin-top: 1rem;
text-shadow: 1px 1px 2px #DDDDDD;
}


@media screen and (min-width: 2300px) {
.large1 {
margin-left: 240px;
}

.large2 {
display: block;
position: absolute;
left: 700px;
}

.large3 {
width: 150%;
display: flex;
justify-content: space-evenly;
}

.large4 {
margin-left: 238px;
width: 95%;
}

.large5 {
width: 90%;
}

.large6 {
width: 1300px;
}

.large7 {
width: 1300px;
}

.large8 {
width: 100%;
}

.large9 {
transform: translateY(220px);
}

.large10 {
transform: rotate(180deg) translateX(-1240px) translateY(180px);
}

.large11 {
margin-left: 35rem;
}

}
.component-container a {
color: #0b85a4;
text-decoration: underline;
}
@media (min-width: 940px) and (max-width: 1300px) {
  .large12 {
    margin-right: 10rem;
  }
.large13 {
gap: 25vw;
}


}

@media (min-width: 750px) and (max-width: 940px) {
.large14 {
gap: 10px;
}
}
.component-container a {
color: #0b85a4;
text-decoration: underline;
}

@media (min-width: 2300px) and (max-width: 2600px) {
.large15 {
gap: 15vw;
}
}

.maxcont {
width: max-content;
}

.mdgap15 {
gap: 25vw;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;AACA,kBAAkB;AAClB,sBAAsB;AACtB,mBAAmB;AACnB,uBAAuB;AACvB,gCAAgC;AAChC,uBAAuB;AACvB,YAAY;AACZ;;AAEA;;AAEA,WAAW;AACX,YAAY;AACZ,WAAW;AACX;;AAEA;AACA,aAAa;AACb,mBAAmB;AACnB,mBAAmB;;AAEnB,WAAW;AACX;;AAEA;AACA,aAAa;AACb,sBAAsB;AACtB,mBAAmB;AACnB,uBAAuB;AACvB,WAAW;AACX;;AAEA;AACA,yBAAyB;AACzB,0BAA0B;AAE1B,kCAAkC;AAClC,mBAAmB;AAGnB,gEAAgE;AAChE,mHAAmH;AAEnH,iCAAiC;AACjC;;AAEA;AACA,YAAY;AACZ,wEAAuE;AACvE;;AAEA;AACA,aAAa;AACb,sBAAsB;AACtB,mBAAmB;AACnB,uBAAuB;AACvB,WAAW;AACX;;AAEA;AACA,cAAc;AACd,oBAAoB;AACpB;;AAEA;AACA,UAAU;AACV,YAAY;AACZ,oEAAwE;AACxE;;AAEA;AACA,0BAA0B;AAC1B,eAAe;AACf,gFAAqE;AACrE;;AAEA;AACA,gEAAgE;AAChE,yEAAyE;AACzE;;AAEA;AACA;AACA,4CAA4C;AAC5C;AACA;;AAEA;AACA;AACA,uBAAuB;AACvB;AACA;AACA,yBAAyB;AACzB;AACA;AACA;AACA,iBAAiB;AACjB,cAAc;AACd,kBAAkB;AAClB,mBAAmB;AACnB,qBAAqB;AACrB,gBAAgB;AAChB,gCAAgC;AAChC;;;AAGA;AACA;AACA,kBAAkB;AAClB;;AAEA;AACA,cAAc;AACd,kBAAkB;AAClB,WAAW;AACX;;AAEA;AACA,WAAW;AACX,aAAa;AACb,6BAA6B;AAC7B;;AAEA;AACA,kBAAkB;AAClB,UAAU;AACV;;AAEA;AACA,UAAU;AACV;;AAEA;AACA,aAAa;AACb;;AAEA;AACA,aAAa;AACb;;AAEA;AACA,WAAW;AACX;;AAEA;AACA,4BAA4B;AAC5B;;AAEA;AACA,+DAA+D;AAC/D;;AAEA;AACA,kBAAkB;AAClB;;AAEA;AACA;AACA,cAAc;AACd,0BAA0B;AAC1B;AACA;EACE;IACE,mBAAmB;EACrB;AACF;AACA,SAAS;AACT;;;AAGA;;AAEA;AACA;AACA,SAAS;AACT;AACA;AACA;AACA,cAAc;AACd,0BAA0B;AAC1B;;AAEA;AACA;AACA,SAAS;AACT;AACA;;AAEA;AACA,kBAAkB;AAClB;;AAEA;AACA,SAAS;AACT","sourcesContent":[".App {\ntext-align: center;\nflex-direction: column;\nalign-items: center;\njustify-content: center;\n/* max-width: calc(70% - 1em); */\n/* min-width: 1270px; */\nmargin: auto;\n}\n\n.swiper-button-prev,\n.swiper-button-next {\nwidth: 50px;\nheight: 50px;\ncolor: #000;\n}\n\n.Header {\ndisplay: flex;\nflex-direction: row;\nalign-items: center;\n\nwidth: 100%;\n}\n\n.Content {\ndisplay: flex;\nflex-direction: column;\nalign-items: center;\njustify-content: center;\nwidth: 100%;\n}\n\n.Menu {\nborder: solid 1px #ebebeb;\npadding: 4px 10px 4px 10px;\n-webkit-border-radius: 15px 15px 15px 15px;\nborder-radius: 15px 15px 15px 15px;\nbackground: #f9f9f9;\nbackground: -moz-linear-gradient(top, #f9f9f9 0%, #dfdfe1 100%);\nbackground: -webkit-linear-gradient(top, #f9f9f9 0%, #dfdfe1 100%);\nbackground: linear-gradient(to bottom, #f9f9f9 0%, #dfdfe1 100%);\nfilter: progid😄XImageTransform.Microsoft.gradient( startColorstr='#f9f9f9', endColorstr='#dfdfe1',GradientType=0 );\n-webkit-box-shadow: 0 1px 3px 1px #d3d9d9;\nbox-shadow: 0 1px 3px 1px #d3d9d9;\n}\n\n.cooper_block{\nheight: 70px;\nbackground: url(../public/images/cooper_block.jpg) top center no-repeat;\n}\n\n.Footer {\ndisplay: flex;\nflex-direction: column;\nalign-items: center;\njustify-content: center;\nwidth: 100%;\n}\n\n.App-logo {\nheight: 40vmin;\npointer-events: none;\n}\n\n.menu_spliter{\nwidth: 1px;\nheight: 65px;\nbackground: url(../public/images/menu_separator_bg.jpg) center no-repeat;\n}\n\nbody {\nfont-family: Tahoma, Arial;\nfont-size: 12px;\nbackground: url(../public/images/bg.jpg) top center no-repeat #eef6f6;\n}\n\n.navbar{\nbackground-image: -webkit-linear-gradient(top, #f5f5f5, #e8e8e8);\nbox-shadow: 0 3px 8px 0 rgba(0, 0, 0, 0.2), 0 0 0 1px rgba(0, 0, 0, 0.08);\n}\n\n@media (prefers-reduced-motion: no-preference) {\n.App-logo {\nanimation: App-logo-spin infinite 20s linear;\n}\n}\n\n@keyframes App-logo-spin {\nfrom {\ntransform: rotate(0deg);\n}\nto {\ntransform: rotate(360deg);\n}\n}\n.h1, h1 {\nfont-size: 1.8rem;\ncolor: #5a5a5a;\nfont-family: Arial;\nfont-weight: normal;\nmargin-bottom: 0.5rem;\nmargin-top: 1rem;\ntext-shadow: 1px 1px 2px #DDDDDD;\n}\n\n\n@media screen and (min-width: 2300px) {\n.large1 {\nmargin-left: 240px;\n}\n\n.large2 {\ndisplay: block;\nposition: absolute;\nleft: 700px;\n}\n\n.large3 {\nwidth: 150%;\ndisplay: flex;\njustify-content: space-evenly;\n}\n\n.large4 {\nmargin-left: 238px;\nwidth: 95%;\n}\n\n.large5 {\nwidth: 90%;\n}\n\n.large6 {\nwidth: 1300px;\n}\n\n.large7 {\nwidth: 1300px;\n}\n\n.large8 {\nwidth: 100%;\n}\n\n.large9 {\ntransform: translateY(220px);\n}\n\n.large10 {\ntransform: rotate(180deg) translateX(-1240px) translateY(180px);\n}\n\n.large11 {\nmargin-left: 35rem;\n}\n\n}\n.component-container a {\ncolor: #0b85a4;\ntext-decoration: underline;\n}\n@media (min-width: 940px) and (max-width: 1300px) {\n  .large12 {\n    margin-right: 10rem;\n  }\n.large13 {\ngap: 25vw;\n}\n\n\n}\n\n@media (min-width: 750px) and (max-width: 940px) {\n.large14 {\ngap: 10px;\n}\n}\n.component-container a {\ncolor: #0b85a4;\ntext-decoration: underline;\n}\n\n@media (min-width: 2300px) and (max-width: 2600px) {\n.large15 {\ngap: 15vw;\n}\n}\n\n.maxcont {\nwidth: max-content;\n}\n\n.mdgap15 {\ngap: 25vw;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
